/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsTicketDto } from '../../models/as-ticket-dto';
import { UpdateAsTicketMemoDto } from '../../models/update-as-ticket-memo-dto';

export interface AsControllerUpdateVendorMemo$Params {
  clientWorkspaceId: string;
  ticketId: string;
      body: UpdateAsTicketMemoDto
}

export function asControllerUpdateVendorMemo(http: HttpClient, rootUrl: string, params: AsControllerUpdateVendorMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerUpdateVendorMemo.PATH, 'patch');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.path('ticketId', params.ticketId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AsTicketDto>;
    })
  );
}

asControllerUpdateVendorMemo.PATH = '/api/v1/as/vendor/{clientWorkspaceId}/tickets/{ticketId}/memo';
